import 'dayjs/locale/tr';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import './services/i18n';

ReactDOM.render(<App />, document.getElementById('root'));

reportWebVitals();
